import "../styles/About.css"
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const { language } = useLanguage();

  const content = {
    historyTitle: {
      english: "Our Legacy",
      tamil: "எங்கள் வரலாறு மற்றும் மரபு"
    },
    historyDescription: {
      english: "Dravida Munnetra Kazhagam (DMK) is not just a political party; it is a movement that reshaped the social and political landscape of Tamil Nadu. Born from the Justice Party and the Dravidian Movement, we stand for the rights of the Tamil ",
      tamil: "பாரதிய ஜனதா கட்சி உலகின் மிகப்பெரிய அரசியல் கட்சியாகும். 1980-ல் நிறுவப்பட்ட இக்கட்சி, இந்திய கலாச்சாரம், தேசியவாதம் மற்றும் ஒருங்கிணைந்த மனிதநேயம் ஆகியவற்றிற்காகப் போராடுகிறது. 1984-ல் 2 இருக்கைகளுடன் தொடங்கி இன்று நாட்டை வழிநடத்தும் வரை, எங்கள் பயணம் அர்ப்பணிப்பு மற்றும் தியாகத்தின் கதையாகும்."
    },
    profileTitle: {
      english: "R. Sudha RadhaKrishnan",
      tamil: "ஆர். சுதா ராதாகிருஷ்ணன்"
    },
    ideologyTitle: {
      english: "Our Ideology",
      tamil: "எங்கள் சித்தாந்தம்"
    },
    ideologydes: {
      english: "Based on the principles of Annaism and Dravidian welfare.",
      tamil: "Based on the principles of Annaism and Dravidian welfare."
    },
    leadershipTitle: {
      english: "Visionary Leadership",
      tamil: "தொலைநோக்கு தலைமை"
    },
    journeyTitle: {
      english: "Political Journey",
      tamil: "அரசியல் பயணம்"
    },
    achievementsTitle: {
      english: "Milestones & Achievements",
      tamil: "முக்கிய சாதனைகள்"
    },
    readMore: {
      english: "Read More",
      tamil: "மேலும் வாசிக்க"
    },
    readLess: {
      english: "Read Less",
      tamil: "குறைவாக வாசிக்க"
    }
  };

  const ideologyData = [
    {
      title: {
        english: "Integral Humanism",
        tamil: "ஒருங்கிணைந்த மனிதநேயம்"
      },
      desc: {
        english: "A philosophy that places the human being at the center of development, balancing material and spiritual needs.",
        tamil: "மனிதனை மையமாக வைத்து, பொருளாதார மற்றும் ஆன்மீக தேவைகளை சமநிலைப்படுத்தும் ஒரு தத்துவம்."
      },
      imagee: "/assets/Frame (5).png"
    },
    {
      title: {
        english: "Cultural Nationalism",
        tamil: "கலாசார தேசியம்"
      },
      desc: {
        english: "Belief that India is a cultural nation, and our unity lies in our shared heritage and values.",
        tamil: "இந்தியா ஒரு கலாசார நாடு என்ற நம்பிக்கை, நமது ஒற்றுமை நமது பகிரப்பட்ட பாரம்பரியத்திலும் மதிப்புகளிலும் உள்ளது."
      },
      imagee: "/assets/Frame (6).png"
    },
    {
      title: {
        english: "Development Driven",
        tamil: "வளர்ச்சி சார்ந்த"
      },
      desc: {
        english: "Governance focused on infrastructure, technology, and economic empowerment for all citizens.",
        tamil: "அனைத்து குடிமக்களுக்கும் உள்கட்டமைப்பு, தொழில்நுட்பம் மற்றும் பொருளாதார அதிகாரமளிப்பில் கவனம் செலுத்தும் ஆட்சி."
      },
      imagee: "/assets/Frame (7).png"
    }
  ];

  const leaders = [
    {
      name: {
        english: "Annadurai (Anna)",
        tamil: "Annadurai (Anna)"
      },
      role: {
        english: "Former Chief Minister",
        tamil: "Former Chief Minister"
      },
      desp: {
        english: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years.",
        tamil: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years."
      },
      period: "2018",
      active: false,
      img: "/assets/annad.jpg"
    },
    {
      name: {
        english: "Muthamizh Arignar Kalaignar",
        tamil: "Muthamizh Arignar Kalaignar"
      },
      role: {
        english: "Chief Minister",
        tamil: "Chief Minister"
      },
      desp: {
        english: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years.",
        tamil: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years."
      },
      period: "2020",
      active: false,
      img: "/assets/kailig.jpg"
    },
    {
      name: {
        english: "Thalapathy MK Stalin",
        tamil: "Thalapathy MK Stalin"
      },
      role: {
        english: "Honourable Chief Minister",
        tamil: "Honourable Chief Minister"
      },
      desp: {
        english: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years.",
        tamil: "A literary giant and statesman who dedicated his life to the Tamil people for over 80 years."
      },
      period: "2024",
      active: true,
      img: "/assets/stalin.jpg"
    }
  ];

  const achievements = [
    {
      title: {
        english: "No. 1",
        tamil: "No. 1"
      },
      subtitle: {
        english: "State in Governance Index",
        tamil: "State in Governance Index"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "50% +",
        tamil: "50% +"
      },
      subtitle: {
        english: "Women in Higher Education",
        tamil: "Women in Higher Education"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Top",
        tamil: "Top"
      },
      subtitle: {
        english: "Investment Destination",
        tamil: "Investment Destination"
      },
      img: "/assets/cup.png"
    }
  ];

  const data = [
    {
      year: "1980",
      title: {
        english: "Foundation",
        tamil: "அடிப்படை"
      },
      desc: {
        english: " Formed on April 6, 1980.",
        tamil: " ஏப்ரல் 6, 1980 அன்று உருவாக்கப்பட்டது."
      }
    },
    {
      year: "1984",
      title: {
        english: "First Election",
        tamil: "முதல் தேர்தல்"
      },
      desc: {
        english: "Won 2 seats in Lok Sabha elections.",
        tamil: "மக்களவைத் தேர்தலில் 2 இடங்களை வென்றது."
      }
    },
    {
      year: "1996",
      title: {
        english: "Single Largest Party",
        tamil: "ஒற்றை பெரிய கட்சி"
      },
      desc: {
        english: "Emerges as largest party, Vajpayee becomes PM for 13 days.",
        tamil: "பெரிய கட்சியாக உருவெடுத்தது, வாஜ்பாய் 13 நாட்களுக்கு பிரதமரானார்."
      }
    },
    {
      year: "1998",
      title: {
        english: "NDA Formation",
        tamil: "NDA உருவாக்கம்"
      },
      desc: {
        english: "Formed government under Vajpayee ji's leadership.",
        tamil: "வாஜ்பாய் தலைமையில் அரசாங்கம் உருவாக்கப்பட்டது."
      }
    },
    {
      year: "2014",
      title: {
        english: "Historic Mandate",
        tamil: "வரலாற்று ஆணை"
      },
      desc: {
        english: "Full majority under PM Narendra Modi.",
        tamil: "பிரதமர் நரேந்திர மோடி தலைமையில் முழு பெரும்பான்மை."
      }
    },
    {
      year: "2019",
      title: {
        english: "Re-election",
        tamil: "மீண்டும் தேர்ந்தெடுக்கப்பட்டது"
      },
      desc: {
        english: "Returned with an even bigger mandate of 303 seats.",
        tamil: "303 இடங்கள் என மேலும் பெரிய ஆணையுடன் திரும்பியது."
      }
    }
  ];

  return (
    <div>
      <section className="history-section">
        <h2>{content.historyTitle[language]}</h2>
        <p className="history-desc">
          {content.historyDescription[language]}
        </p>
        <img src="/assets/line.png" alt="" />
      </section>
      {/* <section className="about-highlight-section">
        <div className="about-highlight-container">
          <div className="about-content">
            <h1 className='abi1'>Since 1972</h1>
            <h1 className='abt2'>History of AIADMK</h1>
            <p className='abtp'>The All India Anna Dravida Munnetra Kazhagam (AIADMK) is a major political party in the Indian state of Tamil Nadu and the Union Territory of Puducherry.</p>
            <p className='abtp'>Founded by the legendary M.G. Ramachandran (MGR) on 17 October 1972 as a breakaway faction from the DMK, the party has been a dominant force in Tamil Nadu politics for over five decades.</p>
            <p className='abtp'>Under the dynamic leadership of J. Jayalalithaa, the party reached new heights, implementing revolutionary welfare schemes. Today, led by Edappadi K. Palaniswami, AIADMK continues its journey of service.</p>
          </div>
          <div className="about-image">
            <img
              src="/assets/edapadi.jpg"
              alt="Profile Overview"
              loading="lazy"
            />
          </div>
        </div>
      </section> */}

      <section className="ideology-section">
        <h2>{content.ideologyTitle[language]}</h2>
        <p>{content.ideologydes[language]}</p>
        <div className="ideology-cards">
          {ideologyData.map((item, index) => (
            <div className="ideology-card" key={index}>
              <div className="book-icon"><img src={item.imagee} alt="" /></div>
              <h4>{item.title[language]}</h4>
              <p>{item.desc[language]}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="leadership-section">
        <h2>{content.leadershipTitle[language]}</h2>
        <div className="leader-cards">
          {leaders.map((leader, i) => (
            <div
              key={i}
              className={`leader-card1 ${leader.active ? "active" : ""}`}
            >
              <div className="leader-image">
                <img src={leader.img} alt="" />
              </div>
              <div className="leader-info">
                <h4>{leader.name[language]}</h4>
                <span className="role">{leader.role[language]}</span>
                <span className="period">{leader.desp[language]}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="journey">
        <h2>{content.journeyTitle[language]}</h2>
        <div className="timeline">
          {data.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className={`content ${index % 2 === 0 ? "left" : "right"}`}>
                <h4>{item.title[language]}</h4>
                <p>{item.desc[language]}</p>
              </div>
              {/* YEAR — ALWAYS CENTER */}
              <div className="year">{item.year}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="achievement-section">
        <h2>{content.achievementsTitle[language]}</h2>
        <p>Recognized globally for our governance model</p>
        <div className="achievement-grid">
          {achievements.map((item, i) => (
            <div className="achievement-card" key={i}>
              {/* <div className="achievement-icon"><img src={item.img} alt="" /></div> */}
              <div className='achievement-text'>
                <h4>{item.title[language]}</h4>
                <span>{item.subtitle[language]}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default About